export default "__VITE_ASSET__7f5KcnMM__"